var map = {
	"./account.svg": "cZ/F",
	"./accountAct.svg": "U7vp",
	"./editInfo.svg": "FPz6",
	"./editInfoAct.svg": "qauS",
	"./history.svg": "8vrS",
	"./historyAct.svg": "Xko3",
	"./message.svg": "iuyN",
	"./messageAct.svg": "27L5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VqW9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Menu \.svg$
// module id = VqW9
// module chunks = 1